import React from 'react';
import { RepeatIcon, BrainIcon, HeartIcon, TrophyIcon } from 'lucide-react';
export const SolutionOverviewSlide = () => {
  return <div className="p-8 md:p-16 min-h-[600px] bg-white" data-id="element-1341">
      <h2 className="text-2xl md:text-3xl font-light text-[#333333] mb-6 border-l-4 border-[#d4af37] pl-4" data-id="element-1342">
        De Oplossing: Verfijnde Gamification
      </h2>
      <div className="flex items-center justify-center mb-6" data-id="element-1343">
        
      </div>
      <div className="text-center mb-6" data-id="element-1344">
        <p className="text-lg text-[#666666] max-w-3xl mx-auto leading-relaxed" data-id="element-1345">
          Mosy's gamification-elementen vormen een
          <span className="text-[#d4af37] font-medium" data-id="element-1346">
            {' '}
            subtiel en verfijnd systeem
          </span>{' '}
          met één primair doel:
        </p>
        <h3 className="text-xl md:text-2xl font-light text-[#333333] mt-3 mb-1" data-id="element-1347">
          Het creëren van een therapeutische gewoonte
        </h3>
        <p className="text-[#666666]" data-id="element-1348">
          die zorgt voor consistente betrokkenheid en betere resultaten
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4" data-id="element-1349">
        <div className="bg-[#f7f3ef] p-4 rounded-lg shadow-sm transition-all hover:shadow-md" data-id="element-1350">
          <div className="flex items-center mb-2" data-id="element-1351">
            <div className="w-9 h-9 rounded-full bg-white flex items-center justify-center mr-3 shadow-sm" data-id="element-1352">
              <BrainIcon className="w-5 h-5 text-[#d4af37]" data-id="element-1353" />
            </div>
            <h4 className="text-lg font-light text-[#333333]" data-id="element-1354">
              Psychologisch Onderbouwd
            </h4>
          </div>
          <p className="text-[#666666] text-sm leading-relaxed" data-id="element-1355">
            Gebaseerd op gedragspsychologie en gewoontevorming, niet slechts
            oppervlakkige punten en badges.
          </p>
        </div>
        <div className="bg-[#f7f3ef] p-4 rounded-lg shadow-sm transition-all hover:shadow-md" data-id="element-1356">
          <div className="flex items-center mb-2" data-id="element-1357">
            <div className="w-9 h-9 rounded-full bg-white flex items-center justify-center mr-3 shadow-sm" data-id="element-1358">
              <HeartIcon className="w-5 h-5 text-[#d4af37]" data-id="element-1359" />
            </div>
            <h4 className="text-lg font-light text-[#333333]" data-id="element-1360">
              Therapeutische Waarde
            </h4>
          </div>
          <p className="text-[#666666] text-sm leading-relaxed" data-id="element-1361">
            Elk element is ontworpen om direct bij te dragen aan het mentale
            welzijn en de effectiviteit van de app te vergroten.
          </p>
        </div>
        <div className="bg-[#f7f3ef] p-4 rounded-lg shadow-sm transition-all hover:shadow-md" data-id="element-1362">
          <div className="flex items-center mb-2" data-id="element-1363">
            <div className="w-9 h-9 rounded-full bg-white flex items-center justify-center mr-3 shadow-sm" data-id="element-1364">
              <TrophyIcon className="w-5 h-5 text-[#d4af37]" data-id="element-1365" />
            </div>
            <h4 className="text-lg font-light text-[#333333]" data-id="element-1366">
              Betekenisvolle Progressie
            </h4>
          </div>
          <p className="text-[#666666] text-sm leading-relaxed" data-id="element-1367">
            Gebruikers ervaren echte vooruitgang in hun mentale welzijn,
            versterkt door visuele representatie van hun reis.
          </p>
        </div>
      </div>
      <div className="bg-[#f7f3ef] p-4 rounded-lg" data-id="element-1368">
        <h3 className="text-lg font-light text-[#333333] mb-3 text-center" data-id="element-1369">
          Sleutelprincipes van Mosy's Benadering
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-1370">
          <div className="bg-white p-3 rounded-lg text-center" data-id="element-1371">
            <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-1372">Autonomie</p>
            <p className="text-xs text-[#666666]" data-id="element-1373">
              Gebruikers kiezen hun eigen thema's en pad
            </p>
          </div>
          <div className="bg-white p-3 rounded-lg text-center" data-id="element-1374">
            <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-1375">
              Beheersing
            </p>
            <p className="text-xs text-[#666666]" data-id="element-1376">
              Vooruitgang door consistentie en betrokkenheid
            </p>
          </div>
          <div className="bg-white p-3 rounded-lg text-center" data-id="element-1377">
            <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-1378">
              Doelgerichtheid
            </p>
            <p className="text-xs text-[#666666]" data-id="element-1379">
              Gamification draagt direct bij aan welzijn
            </p>
          </div>
        </div>
      </div>
    </div>;
};